export default "__VITE_ASSET__990613c0__"